// The values the PHP page template injects as inline globals (app/templates/_base.html), read once.
// See .ai/backend-api.md "Pages, partners and APP_TARGET / APP_ADS_TYPE".
declare global {
  var SS: string | undefined;
  var FULLADDR: string | undefined;
  var REVISION: string | undefined;
  var TLD: string | undefined;
  var APP_TARGET: string | undefined;
  var APP_ADS_TYPE: string | undefined;
  var Solitaire: { pageData?: unknown; fromJson?: (d: unknown) => void } | undefined;
}

export type AppTarget = '' | 'self' | 'multiplayer' | 'offline' | 'softgames' | 'games.com' | 'zboze' | 'embedded-rtp' | 'conduit' | string;

/** `/my-score/<hash>.html` pages pass the shared win through `Solitaire.fromJson({...})`. */
export interface PageData {
  place_name: string;
  place_id: string;
  place_winner_name: string | null;
  place_params: { game_type: string; score_type: string; time: string; score: string; moves: string };
  /** The shared win's shuffle pattern ("12,3,..."), when it was stored: the page deals the same cards. */
  place_pattern?: string;
}

const g = globalThis as typeof globalThis & { SS?: string; FULLADDR?: string; REVISION?: string; TLD?: string; APP_TARGET?: string; APP_ADS_TYPE?: string };

function origin(): string {
  return `${location.protocol}//${location.host}/`;
}

/** Reported in the contact mail (legacy Solitaire.VERSION was the platform build; the web app is 2.0.0). */
export const APP_VERSION = 'web-2.0.0';

export const env = {
  /** Static server base URL, ends with `/`. */
  ss: g.SS || origin(),
  /** Site base URL (API calls), ends with `/`. */
  fullAddr: g.FULLADDR || origin(),
  /** `?v=<n>` cache-busting suffix (may be empty). */
  revision: g.REVISION ?? '',
  tld: g.TLD ?? 'pl',
  appTarget: (g.APP_TARGET ?? '') as AppTarget,
  /** `''` means `online` (legacy common.js:5-7). */
  adsType: g.APP_ADS_TYPE || 'online',
  pageData: (globalThis.Solitaire?.pageData ?? null) as PageData | null,
};
